import * as toastr from 'toastr';
import { CustomError } from './fetch';

const toastOptions: any = {
    timeOut: 2500
};

export const successToast = (message: string) => {
    toastr.success(message, 'Succes', toastOptions);
};

export const errorToast = (message: string) => {
    toastr.error(message, 'Fout', toastOptions);
};

export const warningToast = (message: string) => {
    toastr.warning(message, 'Opgelet', toastOptions);
};

export const generalErrorToast = (errors: CustomError[]) => {
    const generalError = errors.find((error: CustomError) => error.key.toLowerCase() === 'general') || errors[0];
        
    if(generalError){
        errorToast(generalError.message);
    }
};
